function getParentTextBlockElement(node) {
    const isBlockElement = node.nodeType === Node.ELEMENT_NODE && node.classList.contains('TextBlock');
    if (isBlockElement) {
        return node;
    }
    if (!node.parentNode) {
        return null;
    }
    return getParentTextBlockElement(node.parentNode);
}
function getOffsetInsideNode(node, selectedNode, selectedNodeOffset, currentOffset = 0) {
    if (node === selectedNode) {
        return [currentOffset + selectedNodeOffset, true];
    }
    let foundSelectedNode = false;
    if (node.nodeType === Node.TEXT_NODE) {
        const length = node.textContent ? node.textContent.length : 0;
        currentOffset += length;
    }
    else {
        node.childNodes.forEach((childNode) => {
            if (foundSelectedNode) {
                return;
            }
            [currentOffset, foundSelectedNode] = getOffsetInsideNode(childNode, selectedNode, selectedNodeOffset, currentOffset);
        });
    }
    return [currentOffset, foundSelectedNode];
}
function getNodeAndOffsetToSetSelection(node, offset) {
    if (offset === 0) {
        return [offset, node];
    }
    if (node.nodeType === Node.TEXT_NODE) {
        const length = node.textContent ? node.textContent.length : 0;
        if (length < offset) {
            offset -= length;
        }
        else {
            return [offset, node];
        }
    }
    else {
        for (let lp = 0; lp < node.childNodes.length; lp++) {
            let foundNode = null;
            [offset, foundNode] = getNodeAndOffsetToSetSelection(node.childNodes[lp], offset);
            if (foundNode) {
                return [offset, foundNode];
            }
        }
    }
    return [offset, null];
}
export function setSelection(startNode, startOffset, endNode, endOffset) {
    const range = new Range();
    const [offset, node] = getNodeAndOffsetToSetSelection(startNode, startOffset);
    if (node) {
        range.setStart(node, offset);
    }
    if (!endNode) {
        range.collapse(true);
    }
    else if (endOffset) {
        const [offset, node] = getNodeAndOffsetToSetSelection(endNode, endOffset);
        if (node) {
            range.setEnd(node, offset);
        }
    }
    const selection = window.getSelection();
    if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
    }
}
function handleSelectionInNoneSelectableElement(selection) {
    // When collapsed: If it is at 0, move to beginning of next element (if none exists deselect), else move to the end of text above.
    // Range: If both ends are image, deselect
    // Range: If start is in image, set start to next element at 0
    // Range: If end is in image, set end to end of whole element (TextBlock--image)
    selection.removeAllRanges();
}
export function getSelection(insideElement) {
    const doc = insideElement.ownerDocument;
    const window = doc.defaultView;
    if (!window) {
        return;
    }
    const selection = window.getSelection();
    if (!selection) {
        return;
    }
    if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        if (range.startContainer && range.startContainer.nodeType === Node.ELEMENT_NODE) {
            const startContainer = range.startContainer;
            if (startContainer.classList.contains('TextBlock--excluded')) {
                handleSelectionInNoneSelectableElement(selection);
                return getSelection(insideElement);
            }
        }
        else if (range.endContainer && range.endContainer.nodeType === Node.ELEMENT_NODE) {
            const endContainer = range.endContainer;
            if (endContainer.classList.contains('TextBlock--excluded')) {
                handleSelectionInNoneSelectableElement(selection);
                return getSelection(insideElement);
            }
        }
        const startElement = getParentTextBlockElement(range.startContainer);
        if (!startElement) {
            return;
        }
        const [startOffset, foundSelectedStartNode] = getOffsetInsideNode(startElement, range.startContainer, range.startOffset, 0);
        if (!foundSelectedStartNode) {
            throw new Error(`Selected start node was not found.`);
        }
        const endElement = getParentTextBlockElement(range.endContainer);
        if (!endElement) {
            return;
        }
        const [endOffset, foundSelectedEndNode] = getOffsetInsideNode(endElement, range.endContainer, range.endOffset, 0);
        if (!foundSelectedEndNode) {
            throw new Error(`Selected end node was not found.`);
        }
        const startId = startElement.getAttribute('data-id');
        if (!startId) {
            throw new Error('Start element ID not found.');
        }
        const endId = endElement.getAttribute('data-id');
        if (!endId) {
            throw new Error('End element ID not found.');
        }
        let startIsCompletelySelected = (0 === startOffset);
        let endIsCompletelySelected = (endElement.textContent ? endElement.textContent.length : 0) <= endOffset;
        if (startElement === endElement) {
            const isCompletelySelected = startIsCompletelySelected && endIsCompletelySelected;
            startIsCompletelySelected = isCompletelySelected;
            endIsCompletelySelected = isCompletelySelected;
        }
        const inBetweenIds = [];
        if (startElement !== endElement) {
            let currentElement = startElement.nextElementSibling;
            while (currentElement) {
                if (currentElement === endElement) {
                    break;
                }
                const id = currentElement.getAttribute('data-id');
                if (!id) {
                    throw new Error('Found element in in between start and end that had no ID.');
                }
                inBetweenIds.push(id);
                currentElement = currentElement.nextElementSibling;
            }
        }
        return new TextBlockSelection(startId, startOffset, startIsCompletelySelected, !range.collapsed, endId, endOffset, endIsCompletelySelected, inBetweenIds);
    }
}
export default class TextBlockSelection {
    constructor(startBlockId, startPosition, startCompletelySelected, isRange, endBlockId, endPosition, endCompletelySelected, inBetweenBlockIds) {
        this.startBlockId = startBlockId;
        this.startPosition = startPosition;
        this.startCompletelySelected = startCompletelySelected;
        this.isRange = isRange;
        this.endBlockId = endBlockId;
        this.endPosition = endPosition;
        this.endCompletelySelected = endCompletelySelected;
        this.inBetweenBlockIds = inBetweenBlockIds;
    }
}
